import { render, staticRenderFns } from "./CabecalhoItens.vue?vue&type=template&id=7b1de3a0"
import script from "./CabecalhoItens.vue?vue&type=script&lang=js"
export * from "./CabecalhoItens.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoItens.vue?vue&type=style&index=0&id=7b1de3a0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports